import { FormMode } from "enums";
import React from "react";
import AccountTypeVipTiersFormModule from "../account-type-vip-tiers/account-type-vip-tiers-form.module";

const EditAccountTypeVipModule = (props) => {
  const accountTypeId = props.location.state ? props.location.state.accountTypeId : "";

  return <AccountTypeVipTiersFormModule pageMode={FormMode.Edit} accountTypeId={accountTypeId} />;
};

export default EditAccountTypeVipModule;
